import React from "react";
import SideBarWrapper from "../common/pageLayout/SideBarWrapper";
import PropTypes from "prop-types";

const PythonHome = ({match}) => (
  <SideBarWrapper pageType="pythonHome" parentRouteUrl={match.path}/>
);

PythonHome.propTypes = {
  match:PropTypes.object,
};

export default PythonHome;
